import AxiosClient from "../AxiosClient";

export const getProductClassS = (params) => {
  const url = "/api/productClassS/searchInfoList";
  return AxiosClient.post(url, params);
};
